import { render, staticRenderFns } from "./options-toolbar-button.vue?vue&type=template&id=d508be6e"
import script from "./options-toolbar-button.vue?vue&type=script&lang=js"
export * from "./options-toolbar-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports